module.exports = __webpack_public_path__ + "static/media/HDFC.a48243e2.svg";